import { render } from "./NetWorth.vue?vue&type=template&id=5f60fc45&scoped=true"
import script from "./NetWorth.vue?vue&type=script&lang=js"
export * from "./NetWorth.vue?vue&type=script&lang=js"

import "./NetWorth.vue?vue&type=style&index=0&id=5f60fc45&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f60fc45"]])

export default __exports__